/* assets/egg-bounce.js */
(function () {
  const CART_ICON_ID = 'cart-icon-bubble';

  function bounce(node) {
    if (!node) return;
    node.classList.remove('egg-bounce');
    // reflow to restart animation
    // eslint-disable-next-line no-unused-expressions
    node.offsetWidth;
    node.classList.add('egg-bounce');
    node.addEventListener('animationend', () => node.classList.remove('egg-bounce'), { once: true });
  }

  function start() {
    const icon = document.getElementById(CART_ICON_ID);
    if (!icon) return;

    const getBubble = () => icon.querySelector('.cart-count-bubble');

    const obs = new MutationObserver((muts) => {
      const bubble = getBubble();
      if (!bubble) return;

      for (const m of muts) {
        if (m.type === 'childList') {
          if ([...m.addedNodes].some(n => n.nodeType === 1 && n.matches?.('.cart-count-bubble'))) {
            bounce(bubble);
            return;
          }
        }
        if (m.type === 'characterData' || (m.type === 'childList' && bubble.contains(m.target))) {
          bounce(bubble);
          return;
        }
      }
    });

    obs.observe(icon, { childList: true, subtree: true, characterData: true });

    // if bubble exists on load, pop once
    const existing = getBubble();
    if (existing) requestAnimationFrame(() => bounce(existing));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
